"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = ({
  size = 24,
  width = size,
  height = size,
  ...restProps
}) => /*#__PURE__*/_react.default.createElement("svg", _extends({
  width: width,
  height: height,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, restProps), /*#__PURE__*/_react.default.createElement("ellipse", {
  rx: "1.71326",
  ry: "1.71326",
  transform: "matrix(1 0 0.0070234 0.999975 12.0002 11.9769)",
  fill: "#121213"
}), /*#__PURE__*/_react.default.createElement("circle", {
  r: "1.71326",
  transform: "matrix(1 0 0.00702336 0.999975 11.9992 4.21321)",
  fill: "#121213"
}), /*#__PURE__*/_react.default.createElement("circle", {
  r: "1.71326",
  transform: "matrix(-1 -8.74228e-08 -0.00702327 -0.999975 11.9993 19.7868)",
  fill: "#121213"
}), /*#__PURE__*/_react.default.createElement("ellipse", {
  rx: "1.71326",
  ry: "1.71326",
  transform: "matrix(-0.809017 -0.587785 0.582089 -0.813125 7.42274 18.305)",
  fill: "#121213"
}), /*#__PURE__*/_react.default.createElement("ellipse", {
  rx: "1.71326",
  ry: "1.71326",
  transform: "matrix(0.809017 0.587785 -0.582089 0.813125 16.5782 5.70481)",
  fill: "#121213"
}), /*#__PURE__*/_react.default.createElement("circle", {
  r: "1.71326",
  transform: "matrix(0.809017 -0.587785 0.593453 0.804869 7.4233 5.7059)",
  fill: "#121213"
}), /*#__PURE__*/_react.default.createElement("circle", {
  r: "1.71326",
  transform: "matrix(-0.809017 0.587785 -0.593453 -0.804869 16.5767 18.298)",
  fill: "#121213"
}), /*#__PURE__*/_react.default.createElement("circle", {
  r: "1.71326",
  transform: "matrix(-0.309017 -0.951057 0.948863 -0.315689 4.59524 14.4098)",
  fill: "#121213"
}), /*#__PURE__*/_react.default.createElement("ellipse", {
  rx: "1.71326",
  ry: "1.71326",
  transform: "matrix(0.309017 0.951057 -0.948863 0.315689 19.4048 9.59213)",
  fill: "#121213"
}), /*#__PURE__*/_react.default.createElement("ellipse", {
  rx: "1.71326",
  ry: "1.71326",
  transform: "matrix(0.309017 -0.951057 0.953203 0.30233 4.59464 9.5956)",
  fill: "#121213"
}), /*#__PURE__*/_react.default.createElement("ellipse", {
  rx: "1.71326",
  ry: "1.71326",
  transform: "matrix(-0.309017 0.951057 -0.953203 -0.30233 19.4044 14.4025)",
  fill: "#121213"
}));

exports.default = _default;